/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export type VisualisationType =
  'Trend' | 
  'Aggregate'


export function VisualisationTypeFromJSON(json: any): VisualisationType {
    return VisualisationTypeFromJSONTyped(json, false);
}

export function VisualisationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): VisualisationType {
    return json as VisualisationType;
}

export function VisualisationTypeToJSON(value?: VisualisationType | null): any {
    return value as any;
}

